var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 7,
    x: 9,
    y: 2,
    fill: "#fff",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.3835 17V31.4304H22.6591C22.8125 27.7156 23.8387 24.0987 25.6571 20.8727C23.1565 18.6479 19.9308 17.2226 16.3835 17ZM3.72402 22.325C5.21035 25.1318 6.05635 28.2404 6.2 31.4304H0C0.217578 27.9624 1.58428 24.8012 3.72402 22.325ZM6.2 33.3835H0C0.217578 36.8514 1.58428 40.0126 3.72402 42.4888C5.21035 39.682 6.05635 36.5734 6.2 33.3835ZM24.614 33.3835C24.7576 36.5734 25.6036 39.682 27.0899 42.4888C29.2297 40.0126 30.5963 36.8514 30.814 33.3835H24.614ZM14.4304 31.4304H8.15488C8.00146 27.7157 6.97529 24.0987 5.15684 20.8727C7.65742 18.6479 10.8832 17.2226 14.4304 17V31.4304ZM14.4304 33.3835H8.15488C8.00146 37.0981 6.97529 40.715 5.15674 43.9411C7.65742 46.1658 10.8831 47.5913 14.4304 47.8139V33.3835ZM16.3836 33.3835H22.6591C22.8125 37.0981 23.8387 40.715 25.6572 43.9411C23.1566 46.1658 19.9309 47.5913 16.3836 47.8139V33.3835ZM27.0898 22.325C25.6035 25.1318 24.7575 28.2404 24.6139 31.4304H30.8139C30.5963 27.9624 29.2297 24.8012 27.0898 22.325Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.9692 15.1817L12.3169 11H22.0002V16.2469C19.9906 15.4425 17.7971 15 15.5002 15C14.6407 15 13.7956 15.062 12.9692 15.1817ZM30.1996 23H33.0002V11H24.0002V17.1993C26.5113 18.5973 28.6425 20.5955 30.1996 23ZM35.0002 23H37.7193C40.691 23 43.215 20.8247 43.6536 17.8856L44.6812 11H35.0002V23Z",
    clipRule: "evenodd",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.fb8d171cfd7926604dea04f011573870.svg";
export { ForwardRef as ReactComponent };